import { render } from "./PartDesign.vue?vue&type=template&id=4aca17c0"
import script from "./PartDesign.vue?vue&type=script&lang=js"
export * from "./PartDesign.vue?vue&type=script&lang=js"
script.render = render

export default script